export enum Mode {
  Calculate = 0,
  Optimize = 1
}